import { navigationMenuVisibilityRules } from '../constants/navigationMenuVisibilityRules'
import { NavigationMenuVisibilityConditions } from '../hooks/useNavigationMenuVisibilityConditions'
import { NavigationMenuItemId } from '../types/NavigationMenuItemId'

export const isNavigationMenuItemVisible = (
  id: NavigationMenuItemId,
  conditions: NavigationMenuVisibilityConditions,
): boolean => {
  const rule = navigationMenuVisibilityRules[id]
  return rule ? rule(conditions) : true
}
